module.exports = __webpack_public_path__ + "roboto-v15-latin-300.ecce92d0b0ff17197f29.woff";


//////////////////
// WEBPACK FOOTER
// /app/src/assets/layout/fonts/roboto-v15-latin-300.woff
// module id = ../../../../../src/assets/layout/fonts/roboto-v15-latin-300.woff
// module chunks = 2